import * as React from 'react';
import styled from 'styled-components';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ReactSelect from 'react-select-v1';
import 'react-select-v1/dist/react-select.css';
import { Icon } from 'primitive-components';
import { colors, elevation } from 'bench-style-constants';
const StyledComboBoxWrapper = styled.div`
  .Select-control {
    border: 0;
    color: ${colors.charcoal};
  }

  .Select-control:hover {
    box-shadow: none;
  }

  .Select-control,
  .Select.is-focused > .Select-control,
  .Select.is-focused:not(.is-open) > .Select-control,
  .Select.is-open > .Select-control {
    background: ${colors.shell};
    border-radius: 0.25rem;
  }

  .Select.is-focused:not(.is-open) > .Select-control {
    box-shadow: inset 0 0 0 1px ${colors.stream};
  }

  .Select--single > .Select-control,
  .Select-placeholder,
  .Select-value,
  .Select-value-label,
  .Select-input,
  .Select-input > input {
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
  }

  .Select--single > .Select-control,
  .Select-placeholder,
  .Select-value {
    height: auto;
    padding: 8px 16px;
  }

  .Select.has-value.Select--single > .Select-control .Select-value {
    padding: 8px 16px;
    padding-right: 48px;
  }

  .Select-placeholder {
    color: ${colors.dust};
  }

  .Select-multi-value-wrapper,
  .Select-value-label {
    display: block;
  }

  .Select-input,
  .Select-input > input {
    display: block !important; // Overrides react-select JS-applied inline styles
    height: auto;
    padding: 0;
  }

  .Select-clear-zone,
  .Select-arrow-zone {
    position: absolute;
    top: 0;
    bottom: 0;
    display: block;
    width: auto;
    padding: 8px 12px;
  }

  .Select-control > *:last-child {
    padding-right: 12px;
  }

  .Select-clear-zone {
    right: 32px;

    &:hover {
      color: ${colors.copper};
    }
  }

  .Select-clear {
    font-size: 20px;
    line-height: 24px;
  }

  .Select-arrow-zone {
    right: 0;

    path {
      fill: ${colors.dust};
    }
  }

  .Select-menu-outer {
    margin-top: 4px;
    border: 0;
    border-radius: 0.25rem;
    overflow: hidden;
    box-shadow: ${elevation.level2};
  }

  .Select-option {
    padding: 8px 16px;
    font-weight: 300;
  }

  .Select-option.is-selected {
    background-color: ${colors.brook};
  }

  .Select-option.is-focused {
    background-color: ${colors.stream};
  }

  .Select-option:not(:last-child) {
    border-bottom: 1px solid ${colors.shell};
  }
`;

const ArrowRenderer = ({
  onMouseDown,
  isOpen,
}: {
  onMouseDown: (...args: Array<any>) => any;
  isOpen: boolean;
}) => {
  if (isOpen) {
    return <Icon icon="caretUp" onMouseDown={onMouseDown} />;
  }

  return <Icon icon="caretDown" onMouseDown={onMouseDown} />;
};

type ComboBoxInputProps = JSX.LibraryManagedAttributes<
  typeof ReactSelect,
  React.ComponentProps<typeof ReactSelect>
>;

const ComboBoxInput = (props: ComboBoxInputProps) => (
  <StyledComboBoxWrapper>
    <ReactSelect {...props} arrowRenderer={ArrowRenderer} />
  </StyledComboBoxWrapper>
);

ComboBoxInput.defaultProps = {
  ...ReactSelect.defaultProps,
  searchable: true,
};
export default ComboBoxInput;
